// automatically generated by the FlatBuffers compiler, do not modify
// @ts-nocheck
import { flatbuffers } from "flatbuffers";

export class JSONEncodedFBArray {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): JSONEncodedFBArray {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsJSONEncodedFBArray(
    bb: flatbuffers.ByteBuffer,
    obj?: JSONEncodedFBArray
  ): JSONEncodedFBArray {
    return (obj || new JSONEncodedFBArray()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb
    );
  }

  static getSizePrefixedRootAsJSONEncodedFBArray(
    bb: flatbuffers.ByteBuffer,
    obj?: JSONEncodedFBArray
  ): JSONEncodedFBArray {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new JSONEncodedFBArray()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb
    );
  }

  data(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index)
      : 0;
  }

  dataLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  dataArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset)
        )
      : null;
  }

  static startJSONEncodedFBArray(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addData(builder: flatbuffers.Builder, dataOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, dataOffset, 0);
  }

  static createDataVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startDataVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static endJSONEncodedFBArray(
    builder: flatbuffers.Builder
  ): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createJSONEncodedFBArray(
    builder: flatbuffers.Builder,
    dataOffset: flatbuffers.Offset
  ): flatbuffers.Offset {
    JSONEncodedFBArray.startJSONEncodedFBArray(builder);
    JSONEncodedFBArray.addData(builder, dataOffset);
    return JSONEncodedFBArray.endJSONEncodedFBArray(builder);
  }
}
